import { render, staticRenderFns } from "./about-us-page.html?vue&type=template&id=50b57804&scoped=true&external"
import script from "./about-us-page.js?vue&type=script&lang=js&external"
export * from "./about-us-page.js?vue&type=script&lang=js&external"
import style0 from "./about-us-page.scss?vue&type=style&index=0&id=50b57804&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b57804",
  null
  
)

export default component.exports